module.exports = {
  dev: {
    apiUrl: '//127.0.0.1:8088',
    authURL: '//127.0.0.1:8088',
    loginUrl: '//services-preprod.bimedia-it.com/ws-authentication/authentication/front/account/index?mac=0&url=&timestamp=0&terminal=0&license_id=0',
    mediasBimediaHost: 'file:///home/mdelaunay350/W-Workspace/pub-locale-rest/medias'
  },
  preprod: {
    apiUrl: '//services-preprod.bimedia-it.com/pub-locales-ws',
    authURL: '//services-preprod.bimedia-it.com/pub-locales-ws',
    loginUrl: '//services-preprod.bimedia-it.com/ws-authentication/authentication/front/account/index?mac=0&url=&timestamp=0&terminal=0&license_id=0',
    mediasBimediaHost: 'https://medias-preprod.bimedia-it.com'
  },
  prod: {
    apiUrl: '//services.bimedia-it.com/pub-locales-ws',
    authURL: '//services.bimedia-it.com/pub-locales-ws',
    loginUrl: '//services.bimedia-it.com/ws-authentication/authentication/front/account/index?mac=0&url=&timestamp=0&terminal=0&license_id=0',
    mediasBimediaHost: 'https://medias.bimedia-it.com'
  },
  hostVar: '${ mediasBimediaHost }',
  dbStores: [
    'User',
    'Messages'
  ]
}


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/config/config.js
// module id = 16
// module chunks = 0